import i18next from 'i18next'
import React from 'react'
import { relatedContentBlockClasses } from '../../utils/style'
import { getClassName } from '../../utils/utils'
import { RelatedContentItemLayout } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockLayout'
import { NewsOrEvent } from '../cmsPage/blocks/block/relatedContentBlock/relatedContentBlockState'
import { InviewOptions } from '../cmsPage/blocks/blocksState'
import { useInView } from '../hooks/useInView'
import { GenericPageHeader } from '../sharedLayout/pageheader'

type NewsOverviewLayoutProps = {
  index: number
  inview?: InviewOptions
  breadcrumbs: { title: string; url: string }[]
  items: NewsOrEvent[]
}

export const NewsOverviewLayout = (props: NewsOverviewLayoutProps) => {
  const { index, inview, breadcrumbs, items } = props
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("NewsOverviewLayout inView:", inview),
    !inview?.triggerOnce
  )
  return (
    <>
      <GenericPageHeader
        kind="newsOverview"
        breadcrumbs={breadcrumbs}
        title={i18next.t('misc:newsOverviewTitle')}
        intro={i18next.t('misc:newsOverviewIntro')}
      />
      <section
        key={`block-${index}`}
        id={`io-${index}`}
        ref={ref}
        className={getClassName(relatedContentBlockClasses, 'blockClassName', 'container') + ' ' + (inView ? getClassName(relatedContentBlockClasses, 'inviewClassName', 'inview') : '')}
      >
        <div className={getClassName(relatedContentBlockClasses, 'innerClassName', 'py-5')}>
          <div className={getClassName(relatedContentBlockClasses, 'contentClassName', '')}>
            <ul className={getClassName(relatedContentBlockClasses, 'listClassName', 'list-unstyled mb-0 row')}>
              {items.map((item, index) => (
                <RelatedContentItemLayout {...item} key={index} />
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  )
}
